module.exports = __webpack_public_path__ + "static/img/ARADIN1_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARADIN1_1.png
// module id = fjXr
// module chunks = 0